<template>
  <div class="d-flex flex-wrap w-100">
    <!-- <b-col md="4">
      <p class="text-header">
        Campaign Text</p>
    </b-col>
    <b-col md="6">
      <p class="text-child text-justify">
        {{ dataReview.content.campaign_text }} </p>
    </b-col> -->
    <b-col md="4">
      <p class="text-header">
        Sender Name</p>
    </b-col>
    <b-col md="6">
      <p class="text-child">
        {{ dataReview.telco_sender_id }}</p>
    </b-col>
    <!-- <b-col md="4">
      <p class="text-header">
        Action Link</p>
    </b-col>
    <b-col md="6">
      <p class="text-child">
        {{ dataReview.content.action_link }}</p>
    </b-col> -->
  </div>
</template>
<script>
import {
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BCol,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataReview: Object,
  },
  methods: {
    setString(data) {
      let str = (data) || []
      return str.toString()
    },
  },
}
</script>

<style scoped>
.text-header {
  font-size: 14px;
  color: #5E5873;
  font-weight: bold;
}
.text-child {
  font-size: 12px;
  color: #4B6AAE;
}
</style>
